export default "__VITE_ASSET__DDRD8BVH__"